import { Candle } from "@models";

export class OhlcData {
	public candles: Candle[] = [];
	public lastTradingDayStart?: string;
	public lastTradingDayEnd?: string;

	constructor(candles: Candle[], lastTradingDayStart?: string, lastTradingDayEnd?: string) {
		this.candles = candles;
		this.lastTradingDayStart = lastTradingDayStart;
		this.lastTradingDayEnd = lastTradingDayEnd;
	}
}
